import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { memory } from '../pkg/index_bg.wasm';
import { FontManager } from './utils/fontManager';
import { imageStorage } from './service/image_storage';
import { editorStorage } from './service/editor_storage';

import './index.scss';
import Application from './components/Application';
import Footer from './components/Footer';

declare global {
  interface Window {
    requestImageTexture: (id: string) => Promise<void>;
  }
}

import('../pkg')
  .then(async ({ App }) => {
    const app = App.new();
    const persistedApp = app as unknown as {
      export_editor_json: () => string;
      load_editor_json: (editorJson: string) => boolean;
      export_camera_json: () => string;
      load_camera_json: (cameraJson: string) => boolean;
    };

    // Mount global texture loader for Rust
    window.requestImageTexture = async (id: string) => {
      console.log(`[JS] Requesting texture for ${id}`);
      try {
        const record = await imageStorage.getImage(id);
        if (record) {
          const bitmap = await createImageBitmap(record.blob);
          app.update_image_texture(id, bitmap);
        } else {
          console.warn(`[JS] Image ${id} not found in storage.`);
        }
      } catch (e) {
        console.error(`[JS] Failed to load texture ${id}:`, e);
      }
    };

    const fontManager = new FontManager(app, memory);

    // 仅从 IndexedDB 加载持久化数据。
    try {
      const loaded = await editorStorage.loadDocument();
      if (loaded) {
        persistedApp.load_editor_json(loaded.editorJson);
        if (loaded.cameraJson) {
          persistedApp.load_camera_json(loaded.cameraJson);
        }
      }
    } catch (error) {
      console.error('Failed to load persisted editor data from IndexedDB:', error);
    }

    // 立即渲染应用（不等待字体）
    ReactDOM.render(
      <Application app={app} fontManager={fontManager} />,
      document.getElementById('application')
    );

    // 异步初始化字体（加载 eager 字体）
    fontManager.initialize().catch(e => {
      console.error('Failed to initialize fonts:', e);
    });
  })
  .catch(console.error);

const FOOTER_SESSION_KEY = 'footer_seen_in_session';

const shouldRenderFooter = (() => {
  try {
    if (window.sessionStorage.getItem(FOOTER_SESSION_KEY)) {
      return false;
    }
    window.sessionStorage.setItem(FOOTER_SESSION_KEY, '1');
    return true;
  } catch (error) {
    console.warn('sessionStorage unavailable, rendering Footer by default:', error);
    return true;
  }
})();

if (shouldRenderFooter) {
  const el = document.createElement('div');
  document.body.appendChild(el);
  ReactDOM.render(<Footer />, el);
}
